export default __webpack_public_path__ + "static/media/pondInstallation.45961198.jpg";